require('./inactiveAccountsError.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const WizardError = require('components/commons/wizardError/wizardError');

class InactiveAccountsError extends React.Component {
    render() {
        const { navigateToBackButtonText, navigateToBackButtonURL  } = this.props;
        const goBackButtonLabel = <FormattedText value={`inactiveAccountsError-inactiveAccountsError_${navigateToBackButtonText}BackButtonText`} format="uppercase"/>;
        const linkToDetails = `/myprofile/${navigateToBackButtonURL}`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <div className="inactive-accounts-error col-xs-9 center-block">
                <WizardError
                    errorMessage={formatText('inactiveAccountsError-inactiveAccountsError_title')}
                    mainButton={mainButton}
                >
                    <div className="inactive-accounts-error__content">
                        <FormattedText value="inactiveAccountsError-inactiveAccountsError_content" />
                    </div>
                </WizardError>
            </div>
        );
    }
}

InactiveAccountsError.propTypes = {
    navigateToBackButtonText: PropTypes.string.isRequired,
    navigateToBackButtonURL: PropTypes.string.isRequired
};

module.exports = InactiveAccountsError;
